import { Locale } from '@/helpers/languages';

export interface IProvider {
  name: string;
}

export interface ILocaleContent {
  providers: IProvider[];
}

export type LocaleContentMap = Partial<Record<string, ILocaleContent>> & {
  default: ILocaleContent;
};

export const ProvidersData: LocaleContentMap = {
  [Locale.ENGLISH_AUSTRALIA]: {
    providers: [
      { name: 'boongo' },
      { name: '1spin4win' },
      { name: 'bgaming' },
      { name: 'booming' },
      { name: 'voltent' },
      { name: 'platipus' },
    ],
  },
  [Locale.ENGLISH_CANADA]: {
    providers: [
      { name: 'bgaming' },
      { name: 'gamebeat' },
      { name: 'mascot' },
      { name: 'mancala' },
      { name: '1spin4win' },
      { name: 'platipus' },
    ],
  },
  [Locale.GERMAN]: {
    providers: [
      { name: '1spin4win' },
      { name: 'gamebeat' },
      { name: 'oryx' },
      { name: 'gamzix' },
      { name: 'endorphina' },
      { name: 'bgaming' },
    ],
  },
  [Locale.ENGLISH_NEW_ZEALAND]: {
    providers: [
      { name: 'gamebeat' },
      { name: 'quickfire' },
      { name: 'bgaming' },
      { name: 'mascot' },
      { name: '1spin4win' },
      { name: 'platipus' },
    ],
  },
  default: {
    providers: [
      { name: 'bgaming' },
      { name: 'gamebeat' },
      { name: 'mascot' },
      { name: '1spin4win' },
      { name: 'mancala' },
      { name: 'platipus' },
    ],
  },
};

export const getProvidersDataByLocale = (locale: string): ILocaleContent =>
  ProvidersData[locale] || ProvidersData.default;

export const WHITE_PROVIDERS_ICONS = ['mascot'];
